import { render, staticRenderFns } from "./infectiousDiseaseListCompany.vue?vue&type=template&id=10194344&scoped=true&"
import script from "./infectiousDiseaseListCompany.vue?vue&type=script&lang=js&"
export * from "./infectiousDiseaseListCompany.vue?vue&type=script&lang=js&"
import style0 from "./infectiousDiseaseListCompany.vue?vue&type=style&index=0&id=10194344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10194344",
  null
  
)

export default component.exports